<template lang="html">
  <v-container grid-list-md pb-0 pt-0>
    <v-layout row wrap justify-center mb-3>
      <div class="ta-c">
        <span class="title font-weight-bold ">แก้ไขข้อมูลส่วนตัว</span>
      </div>
    </v-layout>
    <v-form ref="form">
      <v-layout row wrap justify-center>
        <v-flex md6 xs10 class="">
          <v-text-field
            label="รหัสบัตรประชาชน"
            prepend-inner-icon="payment"
            solo
            hide-details
            color="blue"
            v-model="card_sub"
            disabled
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="isCompany">
        <v-flex md6 xs10 class="">
          <v-text-field
            label="ชื่อหน่วยงาน/บริษัท/อื่นๆ*"
            prepend-inner-icon="business"
            solo
            hide-details
            color="blue"
            v-model="company_sub"
            required
            :rules="nameRules"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="!isCompany">
        <v-flex xs10 md6>
          <v-combobox
            :items="listTitle"
            label="พิมพ์หรือเลือกคำนำหน้าชื่อ*"
            solo
            :return-object="false"
            hide-details
            v-model="title"
            :rules="nameRules"
            required
            color="blue"
            item-text="title_name"
            prepend-inner-icon="person"
          ></v-combobox>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="!isCompany">
        <v-flex md3 xs10>
          <v-text-field
            label="ชื่อ*"
            prepend-inner-icon="person"
            solo
            hide-details
            color="blue"
            v-model="name_sub"
            required
            :rules="nameRules"
          ></v-text-field>
        </v-flex>
        <v-flex md3 xs10>
          <v-text-field
            label="นามสกุล*"
            prepend-inner-icon="person"
            solo
            hide-details
            color="blue"
            v-model="surname_sub"
            required
            :rules="nameRules"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md6 xs10>
          <v-text-field
            label="ที่อยู่*"
            prepend-inner-icon="home"
            solo
            hide-details
            color="blue"
            v-model="address"
            required
            :rules="nameRules"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md6 xs10>
          <v-text-field
            label="เบอร์โทรศัพท์*"
            prepend-inner-icon="call"
            solo
            hide-details
            color="blue"
            v-model="phone"
            :rules="phoneRules"
            ref="phone_ref"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md6 xs10>
          <v-text-field
            label="อีเมล"
            prepend-inner-icon="email"
            solo
            hide-details
            color="blue"
            v-model="email"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row wrap justify-center mt-4 w-100>
      <v-flex md2 xs5 sm4>
        <div class="ta-c">
          <v-btn color="" round block class="mx-0" @click="reset()"
            >ยกเลิก</v-btn
          >
        </div>
      </v-flex>
      <v-flex md2 xs5 sm4>
        <div class="ta-c">
          <v-btn
            color="primary"
            round
            block
            class="mx-0"
            @click="updateProfile()"
            >บันทึก</v-btn
          >
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
import { Decode } from "@/services";
export default {
  props: ["emit_cardid"],
  data() {
    return {
      items: ["นาย", "นาง", "นางสาว", "ด.ช.", "ด.ญ."],
      card_id: "",
      title: "",
      name: "",
      surname: "",
      address: "",
      phone: "",
      email: "",
      checkbox: false,
      mask: "#############",
      date: "",
      emailRules: [
        (v) => v || "Name is not required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      nameRules: [(v) => !!v || "Name is required"],
      listInformation: [],
      isCompany: false,
      listTitle: [],
      phoneRules: [(v) => /^[0-9*]{9,10}$/.test(v) || "E-mail must be valid"],
      card_sub: "",
      name_sub: "",
      surname_sub: "",
      company_sub: "",
      status: "",
      company: "",
    };
  },
  created() {
    var result = Decode.decode(this.$cookies.get("token"));
    this.card_id = JSON.parse(result).card_id;
    // console.log(this.card_id);

    // var name = Decode.decode(this.$cookies.get("name"));
    // this.name = JSON.parse(name).name;
    // console.log(this.name);

    var status_encode = Decode.decode(this.$cookies.get("status"));
    // console.log(JSON.parse(status_encode));
    this.status = JSON.parse(status_encode).status;

    if (this.status === "people") {
      this.isCompany = false;
    } else {
      this.isCompany = true;
    }
    // console.log(this.isCompany);
    this.queryProfile();
    if (this.status === "people") {
      this.queryTitle();
    }
  },
  methods: {
    moment() {
      this.date = moment().format();
    },
    reset() {
      this.title = this.listInformation[0].title;
      this.name = this.listInformation[0].name;
      this.surname = this.listInformation[0].surname;
      this.address = this.listInformation[0].address;
      this.phone = this.listInformation[0].phone;
      this.email = this.listInformation[0].email;
      this.company = this.listInformation[0].company;
      this.queryProfile();
    },
    queryTitle() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryTitle")
        .then((response) => {
          this.listTitle = response.data;
        });
    },
    queryProfile() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryProfile", {
          card_id: this.card_id,
        })
        .then((response) => {
          this.listInformation = response.data;
          // console.log(this.listInformation);
          this.card_sub =
            this.listInformation[0].card_id.substring(0, 5) + "********";
          this.card_id = this.listInformation[0].card_id;

          this.address = this.listInformation[0].address;
          this.phone = this.listInformation[0].phone;
          this.email = this.listInformation[0].email;

          if (this.isCompany) {
            this.company = this.listInformation[0].company;
            this.company_sub =
              this.listInformation[0].company.substring(0, 15) + "****";
          } else {
            this.title = this.listInformation[0].title;
            this.name_sub =
              this.listInformation[0].name.substring(0, 2) + "****";
            this.name = this.listInformation[0].name;
            this.surname_sub =
              this.listInformation[0].surname.substring(0, 2) + "****";
            this.surname = this.listInformation[0].surname;
          }

          if (this.isCompany) {
            this.name = this.company;
          } else {
            this.name = "คุณ" + this.name;
          }

          this.$cookies.set(
            "name",
            this.name,
            "1d",
            "/",
            process.env.VUE_APP_WEB
          );
          // console.log(this.name);
          this.$emit("getUsername", this.name);
        });
    },
    updateProfile() {
      if (this.phone !== "") {
        if (!this.$refs.phone_ref.validate()) {
          this.$swal("กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง", "", "error");
          return;
        }
      }
      if (this.$refs.form.validate()) {
        // console.log(this.company);
        this.axios
          .post(process.env.VUE_APP_IPFLASK + "/updateProfile", {
            card_id: this.card_id,
            title: this.title,
            name: this.name_sub,
            surname: this.surname_sub,
            address: this.address,
            phone: this.phone,
            email: this.email,
            company: this.company_sub,
          })
          .then((response) => {
            if (response.data === "Update Success") {
              this.$swal("แก้ไขข้อมูลส่วนตัวเรียบร้อย", "", "success");
              this.queryProfile();
            }
          });
      } else {
        this.$swal("กรุณากรอกข้อมูลให้ครบถ้วน", "", "error");
      }
    },
  },
};
</script>

<style scoped></style>
